import * as Yup from 'yup';
import {
  emailRegEx,
  phoneRegEx,
  websiteRegex,
  zipCodeRegEx,
} from '../../../utils/RegularExpressions';

const sponsorSchema = Yup.object({
  name: Yup.string().required('Required'),
  address: Yup.string().required('Required'),
  city: Yup.string().required('Required'),
  state: Yup.string().required('Required'),
  zipCode: Yup.string()
    .required('Required')
    .matches(zipCodeRegEx, 'Please enter a valid Zip / Postal code'),
  phone: Yup.string()
    .required('Required')
    .matches(phoneRegEx, 'Please enter a valid phone number'),
  email: Yup.string()
    .required('Required')
    .matches(emailRegEx, 'Please enter a valid email address'),
  ownershipPercent: Yup.number()
    .transform((val) => (isNaN(val) ? 0 : val))
    .typeError('Must be a number')
    .required('Required')
    .min(0, 'Should not be negative')
    .max(100, 'Should not exceed 100'),
});

const part1Schema = Yup.object({
  orgInfo: Yup.object({
    businessName: Yup.string().required('Required'),
    businessAddress: Yup.string().required('Required'),
    businessCity: Yup.string().required('Required'),
    state: Yup.string().required('Required'),
    zipCode: Yup.string()
      .typeError('Must be a number')
      .required('Required')
      .matches(zipCodeRegEx, 'Please enter a valid Zip / Postal code'),
    businessPhone: Yup.string()
      .required('Required')
      .matches(phoneRegEx, 'Please enter a valid phone number'),
    website: Yup.string().matches(websiteRegex, {
      excludeEmptyString: true,
      message: 'Please enter a valid website address',
    }),
    establishedDate: Yup.string()
      .required('Required')
      .test('date', `Please select past date`, (val) => {
        if (val) {
          return new Date(val).valueOf() <= new Date().valueOf();
        }
        return true;
      }),
    leadContact: Yup.string().required('Required'),
    phone: Yup.string()
      .required('Required')
      .matches(phoneRegEx, 'Please enter a valid phone number'),
    email: Yup.string()
      .required('Required')
      .matches(emailRegEx, 'Please enter a valid email address'),
    yearsInDevelopment: Yup.number().required('Required'),
    ownOperateAffordableProperties: Yup.string().required('Required'),
    isHandMember: Yup.string().required('Required'),
    haveWorkedWithGreystone: Yup.string().required('Required'),
    canHelp: Yup.string().required('Required'),
    capitalAmount: Yup.number(),
    greystoneHelp: Yup.array(),
    socialDesignation: Yup.string().required('Required'),
    legalStatus: Yup.string().required('Required'),
    sponsors: Yup.array().of(sponsorSchema),
  }),
});

const part2Schema = Yup.object({
  potentialProject: Yup.object({
    streetAddress: Yup.string().required('Required'),
    city: Yup.string().required('Required'),
    state: Yup.string().required('Required'),
    zipCode: Yup.string()
      .required('Required')
      .typeError('Must be a number')
      .matches(zipCodeRegEx, {
        excludeEmptyString: true,
        message: 'Please enter a valid Zip / Postal code',
      }),
    dealType: Yup.string().required('Required'),
    proposedUnits: Yup.number().required('Required'),
    byRight: Yup.string().required('Required'),
    constructionType: Yup.string().required('Required'),
    acquisitionType: Yup.string().required('Required'),
    siteControlStatus: Yup.string().required('Required'),
    acquisitionCost: Yup.number().required('Required'),
    developmentCost: Yup.number().required('Required'),
    preDevelopmentCost: Yup.number().required('Required'),
    moreInfo: Yup.string(),
    financingUse: Yup.array(),
  }),
});

const part3Schema = Yup.object({
  orgExperience: Yup.object({
    priorProjects: Yup.array().of(
      Yup.object({
        address: Yup.string().required('Required'),
        city: Yup.string().required('Required'),
        state: Yup.string().required('Required'),
        zipCode: Yup.string()
          .required('Required')
          .typeError('Must be a number')
          .matches(zipCodeRegEx, {
            excludeEmptyString: true,
            message: 'Please enter a valid Zip / Postal code',
          }),
        projectType: Yup.string().required('Required'),
        constructionType: Yup.string().required('Required'),
        completionDate: Yup.string()
          .required('Required')
          .test('date', `Please select past date`, (val) => {
            if (val) {
              return new Date(val).valueOf() <= new Date().valueOf();
            }
            return true;
          }),
        status: Yup.string().required('Required'),
        projectCost: Yup.number()
          .typeError('Must be a number')
          .required('Required')
          .min(0, 'Must be a positive number or 0'),
      })
    ),
  }),
});

export const validationSchema = [part1Schema, part2Schema, part3Schema];
